module.exports = require("core-js-pure/stable/array/from");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/array/from.js
// module id = 236
// module chunks = 0 1